module.exports = __webpack_public_path__ + "static/img/IMG_20160327_090505.3c701e40.jpg";